import { Component, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { AuthenticationService } from 'app/services';

import { StorageService } from '../services/storage.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';

@Component({
  selector: 'manifestchoice',
  providers: [StorageService,AuthenticationService],
  templateUrl: './manifestchoice.component.html',
  styleUrls: ['./manifestchoice.component.scss']
})
export class ManifestchoiceComponent {

  storages: any[] = [];
  filteredStorages: any[];
  filterTitle: string;
  filterString: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService) {
  }
  isCH(): boolean{
    return this._authenticationService.getStorageName() == "CH_BSF";
  }
  isDE():boolean{
    return this._authenticationService.getStorageName() == "DE_BSA";
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/manifest/manifestchoice.component.ts